/* file description */

import React, { FC, useState } from 'react';
import { Modal } from 'antd';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import { downloadExl } from './effect/util';
import { ExportButtonProps } from './type';

const ExportButton: FC<ExportButtonProps> = ({
  moduleInfo,
  mergeColumns,
  selectedRows,
  rowSelection,
  request,
  namespaceID,
  moduleID,
  filter,
  requestParams,
  searchParams,
  sorter,
}) => {
  const [exportVisible, setExportVisible] = useState(false);
  const closeModal = () => {
    setExportVisible(false);
  };
  const exportExcel = async () => {
    const codeObject: any = {};
    const fieldNames: any = {};
    mergeColumns.forEach((item: any) => {
      codeObject[item.dataIndex] = item.dataIndex;
      fieldNames[item.dataIndex] = item.title;
    });
    let exportData = [];
    if (rowSelection && selectedRows?.length > 0) {
      exportData = selectedRows;
    } else {
      const res = await request({
        namespaceID,
        moduleID,
        filter,
        moduleInfo,
        requestParams,
        current: 1,
        pageSize: 1000,
        ...(searchParams || {}),
      }, sorter || {});
      exportData = res?.data || [];
    }
    const data = [codeObject, ...(exportData || [])];
    downloadExl(data, `${moduleInfo.name}数据列表`, '', fieldNames);
    setExportVisible(false);
  };

  return (
    <>
      <Modal
        title="导出"
        width="600px"
        open={exportVisible}
        okText="确认导出"
        cancelText="取消"
        onCancel={closeModal}
        onOk={() => exportExcel()}
        maskClosable={false}
      >
        <div style={{ textAlign: 'center' }}>
          目前支持最多导出1000条数据
        </div>
      </Modal>
      <ButtonLayout
        key="export"
        onClick={() => {
          setExportVisible(true);
        }}
      >
        {rowSelection ? '批量导出' : '导出'}
      </ButtonLayout>
    </>
  );
};
export default ExportButton;